<template>
  <header id="pageHeader">
    <div class="container">
      <div class="content">
        <h1>{{ title }}</h1>
        <div v-if="content" v-html="content"></div>
      </div>
      <div class="image">
        <img :src="headerImage" width="800" height="290">
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'page-header',
  props: ['title', 'content', 'image'],
  data () {
    return {
      headerImage: require('../../assets/images/' + this.image)
    }
  }
}
</script>


<style lang="scss">
  @import "~assets/styles/vars";

  #pageHeader {
    color: $white;
    background-color: $dkBrown;
    .container {
      @extend %noPadContainer;
      display: flex;
      flex-direction: column-reverse;
      @include media('tablet') {
        flex-direction: row;
        align-items: center;
      }
      img {
        width: auto;
        height: 180px;
        @include media('tablet') {
          height: 200px;
        }
        @include media('tablet-wide') {
          height: 290px;
        }
      }
      .content {
        flex: 1;
        text-align: center;
        padding: 20px 0 10px;
        @include media('tablet') {
          padding: 0;
        }
        ul {
          list-style-type: none;
          padding-left: 0;
        }
        a {
          color: inherit;
          &:hover,
          &:focus {
            color: $gold;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PageHeader.vue?dcb90756